import React from "react";

import "./portfolio.css";

// import LAKBAY from "../../assets/Lakbay.png";
// import PETSHOP from "../../assets/dogFriendPetshoppe.png";
// import IGCLONE from "../../assets/igClone.png";

const projects = [
  // {
  //   id: 1,
  //   image: LAKBAY,
  //   title: "Lakbay E-rental App",
  //   demo: "https://lakbay.vercel.app/",
  //   github:
  //     "https://gitlab.com/zuitt-projects-koshikawa/capstone3-koshikawa-deployment",
  // },
  // {
  //   id: 2,
  //   image: PETSHOP,
  //   title: "Lakbay E-rental App",
  //   demo: "https://dogfriend-petshoppe.vercel.app/",
  //   github: "https://github.com/TomK02/dogFriendPetshoppe",
  // },
  // {
  //   id: 2,
  //   image: IGCLONE,
  //   title: "Instagram Clone",
  //   demo: "https://igclone-client-tom.vercel.app",
  //   github: "https://github.com/TomK02/instagramClone-client",
  // },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h2>My Recent Projects</h2>

      <div className="container portfolio__container">
        {projects.length === 0 ? (
          <div className="portfolio__empty">
            <p className="portfolio__empty-title">
              Still building the showcase.
            </p>
            <p className="portfolio__empty-sub">
              Good projects take time to ship right.
            </p>
            <p className="portfolio__empty-hint">
              Come back soon, it will be worth the wait.
            </p>
          </div>
        ) : (
          projects.map(({ id, image, title, github, demo }) => (
            <article key={id} className="portfolio__item">
              <div
                className="portfolio__item-image"
                onClick={() => window.open(`${demo}`, "_blank")}
              >
                <img style={{ height: "20rem" }} src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={demo} target="__blank" className="btn">
                  Demo
                </a>
                <a href={github} target="__blank" className="btn btn-primary">
                  GitHub
                </a>
              </div>
            </article>
          ))
        )}
      </div>
    </section>
  );
};

export default Portfolio;
